import { api } from './index';
export const couriersApi = { async validateCourier({ phoneNumber, courierCode, referredPhoneNumber }) { const path = '/api/internal/couriers'; return api({ method: 'post', url: path, data: { phoneNumber, courierCode, referredPhoneNumber } }).then(response => response.data); } };
